/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_View_Extracted_TextInputs */



/**
* | output |
* | --- |
* | "View extracted text" |
*
* @param {Spaces_View_Extracted_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_view_extracted_text = /** @type {((inputs?: Spaces_View_Extracted_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_View_Extracted_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Extrahierten Text anzeigen")
	return /** @type {LocalizedString} */ ("View extracted text")
});